import React, { memo } from "react"

function SvgComponent({ width = 30, height = 25, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} {...props}>
      <title>{"Twitter"}</title>
      <path
        d="M26.633 3.884c1.195-.845 2.065-1.93 2.544-3.401-.164.08-.273.127-.376.187-1.034.596-2.14.994-3.295 1.266-.183.044-.296.004-.422-.125C24.233.927 23.2.357 22.017.13c-2.048-.392-3.893.089-5.437 1.547-1.404 1.327-2.062 2.99-1.971 4.948.016.364.069.726.108 1.129-5.16-.363-9.377-2.578-12.72-6.587C1.21 2.623.982 4.136 1.33 5.728c.348 1.59 1.213 2.837 2.55 3.83-1.023-.01-1.89-.318-2.753-.747-.009 1.145.245 2.171.772 3.125.904 1.633 2.27 2.645 4.04 3.126-.863.25-1.735.258-2.676.12 1.048 2.71 2.935 4.142 5.758 4.398-2.698 2.085-5.684 2.92-8.993 2.61L0 22.256c.54.297 1.078.6 1.622.888 1.317.7 2.717 1.168 4.163 1.485 1.433.314 2.888.41 4.353.358a17.273 17.273 0 006.04-1.287 16.354 16.354 0 005.44-3.667 18.18 18.18 0 002.949-3.95 19.072 19.072 0 001.74-4.248c.476-1.737.708-3.512.637-5.32a.515.515 0 01.218-.476c.323-.254.64-.519.94-.799A11.946 11.946 0 0030 2.974c-1.119.464-2.206.82-3.367.91"
        fill="#FFF"
        fillRule="evenodd"
      />
    </svg>
  )
}

export const TwitterIcon = memo(SvgComponent)

TwitterIcon.displayName = "TwitterIcon"
